import { type ComponentPropsWithRef, forwardRef } from 'react'

import type { ButtonAsync } from '@subaio/components'

import { Button } from './Button'
import { IconWrapper } from './IconWrapper'

type RenderProps = {
	size: number
}

type Props = Omit<ComponentPropsWithRef<typeof ButtonAsync>, 'label'> & {
	renderIcon: (props: RenderProps) => React.JSX.Element
	removeAlignment?: boolean
	size?: number
}

export const ButtonIcon = forwardRef<HTMLButtonElement, Props>(
	({ renderIcon, removeAlignment, size = 24, ...rest }, ref) => {
		const renderIconProps = {
			size,
		}

		return (
			<Button
				ref={ref}
				{...rest}
				label={removeAlignment ? renderIcon(renderIconProps) : <IconWrapper>{renderIcon(renderIconProps)}</IconWrapper>}
			/>
		)
	},
)
